
export const open_link = (navigate, queryParams, link) => {
  window.open(link)
  navigate({pathname: "/link", search: queryParams});
  setTimeout(() => {
    navigate(-1);
  }, 100);
}